import { useNavigate } from 'react-router-dom'
import { CalendarClock, ArrowRight } from 'lucide-react'
import { SectionCard } from '../../patterns/SectionCard'

function timeLabel(iso: string): string {
  return new Date(iso).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false })
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function NextUpCard({ items }: { items: any[] | null }) {
  const navigate = useNavigate()
  return (
    <SectionCard icon={<CalendarClock size={14} />} title="Next up" fill noBodyPadding
      action={
        <button type="button" onClick={() => navigate('/dashboards/today')} className="text-[11px] text-muted-foreground hover:text-foreground transition inline-flex items-center gap-1">
          Open Today <ArrowRight size={11} />
        </button>
      }>
      {(!items || items.length === 0) ? (
        <div className="px-5 py-6 text-center text-xs text-muted-foreground/70">No more events today.</div>
      ) : (
        <div className="divide-y divide-border/60">
          {items.map((it) => (
            <div key={it.id} className="px-5 py-3 flex items-center gap-3 text-sm">
              <span className="text-xs text-primary font-medium tabular-nums shrink-0">{timeLabel(it.at)}</span>
              <span className="truncate">{it.title}</span>
            </div>
          ))}
        </div>
      )}
    </SectionCard>
  )
}
